import { Link } from 'react-router-dom';
import { MapPin, Clock, Calendar, Heart, Star } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatPrice(price) {
  if (!price) return 'Prezzo su richiesta';
  return `€${Number(price).toLocaleString('it-IT', { maximumFractionDigits: 0 })}`;
}

const PLACEHOLDER_IMAGES = {
  jet: '/images/categorie/jet.jpg',
  turboelica: '/images/categorie/turboelica.png',
  elicotteri: '/images/categorie/elicotteri.png',
  ultraleggeri: '/images/categorie/ultraleggeri.png',
  'propulsione-singola': '/images/categorie/propulsione-singola.jpg',
  'propulsione-multipla': '/images/categorie/propulsione-multipla.jpg',
};

export default function ListingCard({ listing, isFavorited, onToggleFavorite }) {
  const imageUrl = listing.images?.length > 0
    ? `${API}/files/${listing.images[0]}`
    : PLACEHOLDER_IMAGES[listing.category] || PLACEHOLDER_IMAGES.jet;

  const handleFav = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onToggleFavorite) onToggleFavorite(listing.listing_id);
  };

  const isFeatured = listing.featured && listing.featured_until && new Date(listing.featured_until) > new Date();

  return (
    <Link
      to={listing.slug ? `/listings/${listing.slug}` : `/listings/${listing.listing_id}`}
      className={`listing-card group relative overflow-hidden bg-zinc-900/50 border block ${isFeatured ? 'border-[#C5A059]/40 ring-1 ring-[#C5A059]/20' : 'border-zinc-800'}`}
      data-testid={`listing-card-${listing.listing_id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-zinc-900">
        <img src={imageUrl} alt={`${listing.title || `${listing.manufacturer || ''} ${listing.model || ''}`.trim()}${listing.year ? ` ${listing.year}` : ''}${listing.location_city ? ` — ${listing.location_city}` : ''} in Vendita | AeroDeals`} title={listing.title || `${listing.manufacturer || ''} ${listing.model || ''}`.trim()} className="listing-image w-full h-full object-cover" loading="lazy" />
        <div className="absolute top-3 left-3 flex items-center gap-1.5">
          {isFeatured && (
            <span className="flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider bg-[#C5A059] text-black px-2 py-1" data-testid={`featured-badge-${listing.listing_id}`}>
              <Star size={10} className="fill-black" /> In Evidenza
            </span>
          )}
          <span className="text-[10px] font-mono uppercase tracking-wider bg-zinc-950/80 text-[#C5A059] px-2 py-1 backdrop-blur-sm">
            {listing.category?.replace('-', ' ')}
          </span>
        </div>
        {onToggleFavorite && (
          <button onClick={handleFav} className="absolute top-3 right-3 w-8 h-8 bg-zinc-950/60 backdrop-blur-sm flex items-center justify-center hover:bg-zinc-950/80 transition-colors" data-testid={`fav-btn-${listing.listing_id}`}>
            <Heart size={16} className={isFavorited ? 'fill-red-500 text-red-500' : 'text-white'} />
          </button>
        )}
      </div>

      <div className="p-4 space-y-3">
        <div>
          <h3 className="text-base font-medium text-white truncate group-hover:text-[#C5A059] transition-colors" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            {listing.title || `${listing.manufacturer} ${listing.model}`}
          </h3>
        </div>

        <div className="flex items-center gap-3 text-xs text-zinc-400">
          {listing.year > 0 && (
            <span className="flex items-center gap-1"><Calendar size={12} /> {listing.year}</span>
          )}
          {listing.total_time > 0 && (
            <span className="flex items-center gap-1 font-mono"><Clock size={12} /> {listing.total_time.toLocaleString()}h</span>
          )}
          {listing.location_city && (
            <span className="flex items-center gap-1"><MapPin size={12} /> {listing.location_city.split(',')[0]}</span>
          )}
        </div>

        <div className="pt-2 border-t border-zinc-800">
          <span className="text-lg font-bold text-[#C5A059]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            {formatPrice(listing.price)}
          </span>
        </div>
      </div>
    </Link>
  );
}
